import React, { Component } from 'react';
import isMobile from '../../vendor/detect-mobile';

export default function (ComposedComponent) {
  class RedirectMobile extends Component {
    componentWillMount() {
      if (this.shouldRedirectToMobile()) return this.redirectToMobile();
      if (this.shouldRedirectToDesktop()) return this.redirectToDesktop();
    }

    shouldRedirectToMobile() {
      return isMobile && window.location.pathname.split('/')[1] !== 'm';
    }

    shouldRedirectToDesktop() {
      return !isMobile && window.location.pathname.split('/')[1] === 'm';
    }

    redirectToMobile() {
      window.location = '/m' + window.location.pathname + window.location.search;
    }

    redirectToDesktop() {
      window.location = window.location.pathname.substr(2);
    }

    render() {
      if (this.shouldRedirectToMobile() || this.shouldRedirectToDesktop()) return <div />;

      return <ComposedComponent {...this.props} />;
    }
  }

  return RedirectMobile;
}



// WEBPACK FOOTER //
// ./src/components/hoc/redirect-mobile.js